import { createContext, useContext, useState, useCallback, useEffect } from "react";
import { CONTENT } from "../lib/content";

const LangContext = createContext(null);

export const LangProvider = ({ children }) => {
  const [lang, setLangState] = useState(() => {
    if (typeof window !== "undefined") {
      const saved = window.localStorage.getItem("cgp_lang");
      if (["it", "en", "es", "fr"].includes(saved)) return saved;
    }
    return "it";
  });

  const setLang = useCallback((l) => {
    setLangState(l);
    try {
      window.localStorage.setItem("cgp_lang", l);
    } catch {}
  }, []);

  useEffect(() => {
    document.documentElement.lang = lang;
  }, [lang]);

  return (
    <LangContext.Provider value={{ lang, setLang, t: CONTENT[lang] }}>
      {children}
    </LangContext.Provider>
  );
};

export const useT = () => useContext(LangContext);
